export default "__VITE_ASSET__CxNWy30F__"